import styled from "styled-components";

export const HeaderSection = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
`;